import userMe from './users/me.js'
import events from './events.js'

export default app => {
  return {
    userMe: userMe(app),
    events: events(app),
  }
}
